import { get, isEmpty } from 'lodash'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Views } from '../../views'

const EditUserProfile = ({ authenticated, keycloak, language }) => {
    useEffect(() => {
        if (!isEmpty(keycloak) && !authenticated) {
            window.location = '/portal'
        }
    }, [authenticated, keycloak])

    const { EditUserProfile } = Views
    return (
        !isEmpty(keycloak) ?
            <EditUserProfile keycloak={keycloak} />
            : null
    )
}

const mapStateToProps = state => ({
    keycloak: get(state, 'keycloak', ''),
    authenticated: get(state, 'keycloak.authenticated', false),
    language: get(state, 'language', 'th')
})

export default connect(mapStateToProps)(EditUserProfile)